/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
/* eslint-disable no-continue */
// generate an expertise report based on user answer
import _ from 'lodash';
import moment from 'moment';
import createDamage from './createDamage';
import addAlert from './addAlert';
import generateAlerts from './generateAlerts';

// keys to add without transformation
const keysToAdd = ['vehicle', 'customer', 'id', 'escape_question', 'expertise', 'pointOfSale'];
const expertiseInspection = {
  dateExpertise: ['date'],
  durationExpertise: ['int'],
  placeExpertise: ['text'],
  buyerName: ['text'],
};
const durations = {
  total: [],
};

const readCommentBuyerAlertEvent = [
  'road_test_damage_comment',
  'road_test_witness_comment',
  'comment_seller',
  'comment_individual',
];

// Add the value and key to both data to display in app, and to the json that will be used to share to the rest of the process
function addToReport(path, type, value, report) {
  let _value = value;
  const defaultDisplayValues = {
    select_multiple: [],
    rim_size: { width: '?', height: '?', diameter: '?' },
    default: '',
  };
  if (path?.trim() === 'equipments.equipments') {
    const pathValue = _.get(report.display, path, null)?.[1];
    _value = [...(Array.isArray(pathValue) ? pathValue : []), ...(Array.isArray(_value) ? _value : [])];
  } else if (_value === null || _value === undefined) {
    if (type === 'image') return;
    if (defaultDisplayValues[type]) _value = defaultDisplayValues[type];
    else _value = defaultDisplayValues.default;
  }
  _.set(report.display, path, [type, _value]);
}

function addCustomCostAlert(zone, id, report) {
  const key = `has_custom_cost ${zone}`;
  const currentAlert = _.get(report, key, []);
  const value = [...currentAlert, id];
  addAlert(report, key, value);
}

function inputDamage(object, report) {
  let custom_damage = '';
  let is_custom = '';
  let damage_picture = '';
  let damage_picture2 = '';
  let cost = null;
  let value = _.get(object, 'value', '');

  // check if damage was manually set
  if (value && typeof value === 'object') {
    const customKey = Object.keys(value)[0];
    is_custom = true;
    custom_damage = _.get(value, `${customKey}.label`, '');
    cost = _.get(value, `${customKey}.cost`, 0);
    value = customKey;
    addCustomCostAlert(object.zone, object.id, report);
  }

  // check if damage has images
  const { images } = object;
  if (images !== undefined) {
    // && Array.isArray(images)){
    damage_picture = _.get(images[0], 'id', null);
    damage_picture2 = _.get(images[1], 'id', null);
  }

  return createDamage({
    cost,
    custom_damage,
    value,
    damage_picture,
    damage_picture2,
    element: object.id,
    is_custom,
    reconditionning: value,
    timestamp: object.timestamp,
    zone: object.zone,
  });
}

function extractValue(dict, report) {
  for (const key in dict) {
    const object = dict[key];
    if (object.displayed === false) {
      _.unset(dict, key);
      continue;
    }
    if (object.id === 'comment_buyer') {
      const comment = _.get(object, 'value', null);
      if (comment) addAlert(report, 'read_the_comment_buyer', '');
    }

    if (object === null || object === undefined || typeof object !== 'object') {
      continue;
    }

    // deal with groups and sections
    if (object.children) {
      extractValue(object.children, report);
      continue;
    }

    // extract timestamp - to make calculation after forloop
    if (object.timestamp) {
      const timestamp = moment(object.timestamp, 'YYYY-MM-DD HH:mm:ss');
      if (!durations[object.zone]) durations[object.zone] = [];
      durations[object.zone].push(timestamp);
      durations.total.push(timestamp);
    }

    // this check if the object is a question to answer from the user
    if (object.input) {
      let path = `${object.zone}.${object.id}`;
      const type = _.get(object, 'type', null);

      if (object.type === 'multiple_photos') {
        const images = _.get(object, 'images', {});
        let count = 1;
        Object.values(images).forEach((image) => {
          if (image.id) {
            addToReport(path + count.toString(), 'image', image.id, report);
            count += 1;
          }
        });
        continue;
      }

      // this check if the field is an info or image
      if (object.input === 'image' || object.type === 'image') {
        if (object.zone.includes('vin_picture') && object.label !== undefined) {
          const label = 'VIN';
          path = `${label} ${object.label}.${object.id}`;
        }
        const image = _.get(object, 'value.id', null);
        addToReport(path, type, image, report);
        continue;
      }
      // this check if the field is an info or image
      if (object.input === 'info' || object.input === 'alert') {
        const value = _.get(object, 'value', null);
        if (type === 'multiple_photos') {
          const images = _.get(object, 'images', null);
          if (images) {
            Object.entries(images).forEach(([key2, value2]) => {
              if (value2.label && value2.id) {
                const path2 = `${object.zone}.${object.images[key2].label}`;
                addToReport(path2, 'image', value2.id, report);
              }
            });
          }
          continue;
        } else {
          addToReport(path, type, value, report);
          if (readCommentBuyerAlertEvent.includes(object.id)) {
            const comment = _.get(object, 'value', null);
            if (comment) addAlert(report, 'read_the_comment_buyer', '');
          }
          if (['odometerOn', 'odometerMileageVisible'].includes(object.id)) {
            const resp = _.get(object, 'value', null);
            if (resp === 'no') addAlert(report, object.id, 'no');
          }
          // this check if the field is an alert
          if (object.input === 'alert') {
            generateAlerts(object, report);
          }

          // check if there is an image
          const image1 = _.get(object, 'images[0].id', null);
          if (image1 !== null) addToReport(`${path}_image`, 'image', image1, report);
          const image2 = _.get(object, 'images[1].id', null);
          if (image2 !== null) addToReport(`${path}_image2`, 'image', image2, report);
          continue;
        }
      }
      // this check if the field is a damage
      if (object.input === 'damage' && object.value) {
        if (['manuel', 'second_set_keys'].includes(object.id))
          addToReport(`${object.zone}.${object.id}`, type, object.value, report);
        const damage = inputDamage(object, report);
        const damages = _.get(report, 'damages', []);
        damages.push(damage);
        _.set(report, 'damages', damages);
        continue;
      }
    }
  }

  // iterate through all the key to calulate the duration of each section et total
  Object.entries(durations).forEach(([key, array]) => {
    const duration = moment.max(array).diff(moment.min(array), 'minutes');
    addToReport(`file.durations.${key}`, 'duration', duration, report);
  });
}

export default async function generateReport(form, referentials) {
  const totals = {};
  Object.values(referentials).forEach((r) => {
    totals[r] = 0;
  });

  const report = {
    display: {
      body: {
        totals,
        damages: [],
      },
    },
  };

  addToReport(`file.recordId`, 'int', form.recordId, report);
  addToReport(`file.buyerId`, 'int', form.buyerId, report);

  for (const key in form.inspection) {
    const object = form.inspection[key];
    if (keysToAdd.includes(key)) {
      if (key === 'escape_question') addAlert(report, 'file_not_finalized', object);
      if (['string', 'number', 'boolean'].includes(typeof object)) {
        addToReport(`file.${key}`, typeof object, object, report);
        continue;
      }
      _.mapKeys(object, (value, id) => {
        let valueType = typeof value;
        if (id === 'registrationDate' || id === 'gcDate') {
          valueType = 'date';
        }
        if (id !== 'versions' && ['date', 'string', 'number', 'boolean'].includes(valueType))
          addToReport(`${key}.${id}`, valueType, value, report);
      });
      continue;
    }
    if (key === 'report') continue;
    if (key !== 'children') continue;

    extractValue(object, report);
  }

  Object.entries(expertiseInspection).forEach(([key, array]) => {
    let value;
    if (key === 'durationExpertise') value = _.get(report, 'display.file.durations.total[1]');
    if (key === 'dateExpertise')
      value = moment(_.get(form, 'inspection.report.expertise.dateExpertise[1]')).format('YYYY-MM-DD HH:mm:ss');
    if (key === 'buyerName')
      value = `${_.get(form, 'inspection.buyer.firstname', '')} ${_.get(form, 'inspection.buyer.lastname', '')}`;
    if (key === 'placeExpertise') value = _.get(form, 'concessionCarcheck.name', '');
    addToReport(`expertise.${key}`, array[0], value, report);
  });

  return report;
}
